import { configureStore } from '@reduxjs/toolkit'
import { combineReducers } from 'redux'
import assets from './reducers/assets'
import drawers from './reducers/drawers'

const reducer = combineReducers({
    assets,
    drawers,
})

const store = configureStore({ reducer })
export type AppState = ReturnType<typeof store.getState>

export default store
